<!-- .menu -->
<div class="menu"
    [ngClass]="{'menu--layout--classic': layout === 'classic', 'menu--layout--topbar': layout === 'topbar'}"
    (mouseleave)="onMouseLeave()" #menuElement>
    <div class="menu__submenus-container">
        <ng-container *ngFor="let item of items">
            <div *ngIf="item.subCategories;" class="menu__submenu"
                [ngClass]="{'menu__submenu--open': item === hoveredItem}" #submenuElement>
                <app-dropdown-categories [items]="item.subCategories" (itemClick)="onSubItemClick($event)">
                </app-dropdown-categories>
            </div>
        </ng-container>
    </div>

    <ul class="menu__list">
        <li *ngFor="let item of items" class="menu__item" [ngClass]="{
                'menu__item--hover': item === hoveredItem
            }" (mouseenter)="onItemMouseEnter(item)" #itemElement>
            <ng-template #link>
                {{ item.name[this.translate.currentLang] }}
                <app-icon *ngIf="item.subCategories" class="menu__item-arrow" name="arrow-rounded-right-6x9"
                    size="6x9"></app-icon>
            </ng-template>

            <a *ngIf="!item.external" class="menu__item-link" [routerLink]="((sector) ? ['/sector', sector] : ['/']).concat(['category', item.seo?.slug])" [target]="item.target"
                (click)="itemClick.emit(item)" (appTouchClick)="onTouchClick($event, item)">
                <ng-container [ngTemplateOutlet]="link"></ng-container>
            </a>
            <a *ngIf="item.external" class="menu__item-link" [href]="item.seo.slug" [target]="item.target"
                (click)="itemClick.emit(item)" (appTouchClick)="onTouchClick($event, item)">
                <ng-container [ngTemplateOutlet]="link"></ng-container>
            </a>
        </li>
    </ul>
</div>
<!-- .menu / end -->
